import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  { path: '/lnetc/:orderId', name: 'LnetcPay', component: () => import('../views/LnetcPay.vue') },
  {
    path: '/jhuid/:orderId',
    name: 'JhuidPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'jhuid' }
  },
  {
    path: '/yz/:orderId',
    name: 'YzPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'yz' }
  },
  {
    path: '/nh/:orderId',
    name: 'NhPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'nh' }
  },
  {
    path: '/zjfs/:orderId',
    name: 'ZjfsPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'zjfs' }
  },
  { path: '/gh/:orderId',
    name: 'GhPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'gh' }
  },
  { path: '/yzyhf/:orderId',
    name: 'YzyhfPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'yzyhf' }
  },
  { path: '/hbnx/:orderId',
    name: 'HbnxPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'hbnx' }
  },
  { path: '/wpgj/:orderId',
    name: 'WpgjPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'wpgj' }
  },
  { path: '/fjnx/:orderId',
    name: 'FjnxPay',
    component: () => import('../views/BankAggPay.vue'),
    meta: { channel: 'fjnx' }
  },
  { path: '/wxjs/:orderId', name: 'WxJsPay', component: () => import('../views/WxJsPay.vue') },
  {
    path: '/jhuidwx/:orderId',
    redirect: to => ({
      name: 'WxJsPay',
      params: { orderId: to.params.orderId },
      query: to.query
    })
  },
  { path: '/zhifutd/:orderId', name: 'ZhifutdPay', component: () => import('../views/ZhifutdPay.vue') },
  { path: '/ywzf/:orderId', name: 'YwzfPay', component: () => import('../views/YwzfPay.vue') },
  { path: '/alipaycard/:orderId', name: 'AlipayCardPay', component: () => import('../views/AlipayCardPay.vue') },
  { path: '/uidmanual/:orderId', name: 'UidManualPay', component: () => import('../views/UidManualPay.vue') },
  { path: '/unified/:orderId', name: 'UnifiedPay', component: () => import('../views/UnifiedPay.vue') },
  { path: '/salary', name: 'SalaryPayout', component: () => import('../views/SalaryPayout.vue') },
  { path: '/error', name: 'Error', component: () => import('../views/Error.vue') },
  // query 才能在地址栏保留错误文案（params 无 path 占位时易丢失）
  { path: '*', redirect: to => ({ name: 'Error', query: { msg: (to.query && to.query.msg) || '页面不存在' } }) }
]

const router = new VueRouter({
  mode: 'hash',
  base: '',
  routes
})

export default router
